import { defineComponent as s, computed as a, openBlock as n, createElementBlock as r, normalizeClass as p, renderSlot as c } from "vue";
import { getTdStyleClasses as d } from "./novoui-vuejs76.js";
const i = /* @__PURE__ */ s({
  __name: "NTd",
  props: {
    loading: { type: Boolean, default: !1 },
    action: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, o = a(() => d(t));
    return (l, f) => (n(), r("td", {
      class: p(o.value)
    }, [
      c(l.$slots, "default")
    ], 2));
  }
});
export {
  i as default
};
